import { CONTACT_CREATOR_TRANSLATION_KEY } from '../../../translation'

const GENERAL_STEP_TRANSLATIONS_NAMESPACE = `${CONTACT_CREATOR_TRANSLATION_KEY}__general-info-validation`

export const TRANSLATION_KEYS = {
  validation: {
    firstNameExceedMaxLength: `${GENERAL_STEP_TRANSLATIONS_NAMESPACE}__first-name-exceed-max-length`,
    lastNameExceedMaxLength: `${GENERAL_STEP_TRANSLATIONS_NAMESPACE}__last-name-exceed-max-length`,
    emailExceedMaxLength: `${GENERAL_STEP_TRANSLATIONS_NAMESPACE}__email-exceed-max-length`,
  },
}
